import { DEFAULT_NON_AWL_SUPPORT_CENTER_URL, nonTranslatableText } from '@va/constants';
import { setIgnoreVisitsLink } from '@va/dashboard/actions/app';
import { setCustomizationOptions, setWindowWidth } from '@va/dashboard/actions/ui';
import { Config as BaseConfig } from '@va/http-client';
import { getAgencyUi, initialize } from '@va/standalone/shared/actions';
import { storageItems } from '@va/standalone/shared/constants';
import { getConfigChatwootToken, isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { createStore } from '@va/store';
import { debounce, LocalStorage, updateFavicon } from '@va/util/helpers';
import Config from 'Config';
import rootReducer from 'standalone/reducers';
import rootSaga from 'standalone/sagas';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const getAuthenticateHeaders = (store: any) => () => {
  const token = LocalStorage.getItem(storageItems.loginToken);
  const headers = {} as Record<string, unknown>;

  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }
  return headers;
};

export function initializeApp() {
  const store = createStore(rootReducer, rootSaga, null);
  BaseConfig.setAuthProvider(getAuthenticateHeaders(store) as any);
  BaseConfig.setApiBaseUrl(Config.apiUrl);
  window.addEventListener(
    'resize',
    debounce(() => {
      store.dispatch(setWindowWidth(window.innerWidth));
    }, 150),
  );

  store.dispatch(
    setCustomizationOptions({
      providerName: nonTranslatableText.appName,
      supportCenterDomain: DEFAULT_NON_AWL_SUPPORT_CENTER_URL,
      chatwootToken: getConfigChatwootToken(),
    }),
  );

  store.dispatch(initialize());
  // Needed for wix websites claimed in standalone.
  store.dispatch(setIgnoreVisitsLink(Config.wixIgnoreVisitsUrl));
  store.dispatch(setWindowWidth(window.innerWidth));

  if (isUserLoggedInWithCustomUrl()) {
    document.title = 'Dashboard';
    updateFavicon('/favicon-awl.ico');
    store.dispatch(getAgencyUi());
  } else {
    document.title = 'TWIPLA | Analytics That Respects Privacy';
    updateFavicon('/favicon-twipla.ico');
  }

  return store;
}
